import React from "react";
import { connect } from "react-redux";
import * as actions from "../../Redux/actions.js"
import { ClaimStatusEnum } from "../../enum.js";
import find from 'lodash/find';
import { getPartnerGuid, hasAuthourity } from "../../../../../lib/access.es6.js";
import ClaimsHeader from "../ClaimsHeader/ClaimsHeader.js";
import ClaimsWrapper from "../ClaimsWrapper/ClaimsWrapper.js";
import { Lawyers } from "../../../ClaimProcessing/Components/ClaimDetails/Lawyers.js";
import AssignLawyerClaim from "../AssignLawyerClaim/AssignLawyerClaim.js";


class LegalClaims extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openAssignLawyerDialog: false,
      selectedClaimGuid: null,
    };
  }  

  componentWillMount() {
    const payload = {
      "partner": getPartnerGuid(),
      "statuses": ClaimStatusEnum.docs_pending
    }
    this.props.dispatch(actions.getClaimsDcpRequest(payload))
  }

  getClaims(payload) {
    this.props.dispatch(actions.getClaimsDcpRequest(payload
    ))
  }

  handleBulkApproval(payload) {
    this.props.dispatch(actions.bulkApproveRequest(payload))
  }


  isLegalClaim(claim) {
    const hasLegalCoverBenefit = !!find(claim.benefits, { type: "Legal Cover" })
     return hasLegalCoverBenefit
   }

  filterLegalClaims(claims){

    return claims.filter(claim => this.isLegalClaim(claim));
  }

  toggleAssignLawyerDialog = (claimGuid = null) => {
    this.setState({ 
      openAssignLawyerDialog: !this.state.openAssignLawyerDialog,
      selectedClaimGuid: claimGuid 
    });
  }

  handleAssignLawyer = (payload) => {
    this.props.dispatch(actions.assignLawyerRequest(payload));
  }

  resetAddLawyerSuccessAlert = () => {
    this.props.dispatch(actions.resetAddLawyerSuccessAlert());
  }

  resetAddLawyerErrorAlert = () => {
    this.props.dispatch(actions.resetAddLawyerError());
  }

  render() {
    const claimEx = this.props.ClaimDashboardCoverLinkData.claims_dcp || []
    const claims = this.filterLegalClaims(claimEx)

    if (!hasAuthourity('VIEW_CLAIM')) {
      return <p>You are unauthorized to view claims.</p>
    }

    return (
      <>
        <ClaimsHeader
          title="Legal Cover Claims Dashboard"
        />

        <ClaimsWrapper
          claimsData={claims}
          type="Legal Cover"
          hasAlerts={true}
          hasBulkApprove={true}
          getClaims={this.getClaims.bind(this)}
          loading={this.props.ClaimDashboardCoverLinkData.get_claims_dcp_loader}
          handleBulkApproval={this.handleBulkApproval.bind(this)}
          lawyers={Lawyers}
          
          // Lawyer assignment props
          toggleAssignLawyerDialog={this.toggleAssignLawyerDialog}
          handleAssignLawyer={this.handleAssignLawyer}

          showBulkApproveProgressAlert={this.props.ClaimDashboardCoverLinkData.bulkApprovalClaimLoader}
          showBulkApproveSuccessAlert={this.props.ClaimDashboardCoverLinkData.bulkApprovalClaimSuccess}
          showBulkApproveErrorAlert={!!this.props.ClaimDashboardCoverLinkData.bulkApprovalClaimError}
          bulkApproveError={this.props.ClaimDashboardCoverLinkData.bulkApprovalClaimError}

          resetBulkApproveSuccessAlert={() => { this.props.dispatch(actions.resetbulkApprovalSuccess()) }}
          resetBulkApproveErrorAlert={() => { this.props.dispatch(actions.resetbulkApprovalFailure()) }}
        />

        <AssignLawyerClaim
          openAssignLawyerDialog={this.state.openAssignLawyerDialog}
          toggleAssignLawyerDialog={this.toggleAssignLawyerDialog}
          claimguid={this.state.selectedClaimGuid}
          assignLawyer={this.handleAssignLawyer}
          
          showAddLawyerProgressAlert={this.props.ClaimDashboardCoverLinkData.assignLawyerLoader}
          showAddLawyerSuccessAlert={this.props.ClaimDashboardCoverLinkData.assignLawyerSuccess}
          showAddLawyerErrorAlert={!!this.props.ClaimDashboardCoverLinkData.assignLawyerError}
          addLawyerError={this.props.ClaimDashboardCoverLinkData.assignLawyerError}
          
          resetAddLawyerSuccessAlert={this.resetAddLawyerSuccessAlert}
          resetAddLawyerErrorAlert={this.resetAddLawyerErrorAlert}
        />
      </>
    )

  }

}
export default connect((state) => ({
  customerData: state.currentCustomer,
  claimDashboardData: state.claimDashboardData,
  ClaimDashboardCoverLinkData: state.ClaimDashboardCoverLinkData,
  globalData: state.global,
}))(LegalClaims);